<template>
  <div style="padding-top: 15px">
    <el-row class="top">
      <el-col :span="6">
        <div class="w1">
          <span class="yuan bg1"></span>
          <span class="t c1">本月待发车(辆)</span>
        </div>
        <div class="w2 bg1">
          <span class="t2">{{ departList.course1 }}</span>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="w1">
          <span class="yuan bg2"></span>
          <span class="t c2">本月运输中</span>
        </div>
        <div class="w2 bg2">
          <span class="t2">{{ departList.course2 }}</span>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="w1">
          <span class="yuan bg3"></span>
          <span class="t c3">本月到达</span>
        </div>
        <div class="w2 bg3">
          <span class="t2">{{ departList.course3 }}</span>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="w1">
          <span class="yuan bg4"></span>
          <span class="t c4">本月超时</span>
        </div>
        <div class="w2 bg4">
          <span class="t2">{{ departList.course4 }}</span>
        </div>
      </el-col>
    </el-row>
    <div class="chart-box">
      <div class="chart" ref="chart"></div>
      <div class="biaoji">
        <div class="t1">总发车量</div>
        <div class="t2">超时订单量</div>
      </div>
    </div>
    <div class="msg">
      <div class="m2">
        <div class="m2-b">
          <img class="m2-i" src="../../static/images/gonggao.png" alt="">
          <span class="m2-t">公告</span>
        </div>
        <!-- <div class="line"></div> -->
        <div class="m2-c">
          <el-carousel ref="carousel" :autoplay="false" :loop="false">
            <el-carousel-item v-for="item in announceList" :key="item.id">
              <p class="title tc">{{ item.title }}</p>
              <p class="time tr">{{ item.time }}</p>
              <p class="content" v-html="item.content"></p>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {announce, roadList, departList, orderList} from '@/api/home'
import * as echarts from 'echarts';

export default {
  data() {
    return {
      announceList: [],
      departList: {},
      orderList: [],
      loading: null
    }
  },
  created() {
    this.loading = this.$loading({
      lock: true,
      text: '拼命加载中...',
      background: 'rgba(0, 0, 0, 0.8)'
    });
  },
  methods: {
    async getAnnounce() {
      const [res] = await this.$ajax(announce, {});
      this.announceList = res.data;

      const [res3] = await this.$ajax(departList, {});
      this.departList = res3.data;

      const [res4] = await this.$ajax(orderList, {});
      this.orderList = res4.data;

      this.loading.close();
      this.renderCanvas();
    },
    renderCanvas() {
      var myChart = echarts.init(this.$refs.chart);
      // 绘制图表
      const _date = new Date();
      const _y = _date.getFullYear()
      const _xdate = [];
      for (let i = 1; i < 13; i++) {
        _xdate.push(`${_y}-${i > 10 ? i : '0' + i}`)
      }
      const _xdata1 = [];
      const _xdata2 = [];
      this.orderList.forEach(item => {
        _xdata1.push(parseInt(item.total) || 0);
        _xdata2.push(parseInt(item.overtime) || 0);
      })
      const option = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: _xdate
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: _xdata1,
            type: 'line',
            smooth: true,
            itemStyle: {
              color: 'rgba(243, 153, 1, 1)'
            },
            lineStyle: {
              color: 'rgba(243, 153, 1, 1)'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(243, 153, 1, 1)'
              }, {
                offset: 1,
                color: 'rgba(243, 152, 0, 0)'
              }])
            }
          },
          {
            data: _xdata2,
            type: 'line',
            smooth: true,
            itemStyle: {
              color: 'rgba(236, 108, 63, 1)'
            },
            lineStyle: {
              color: 'rgba(236, 108, 63, 1)'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(236, 108, 63, 1)'
              }, {
                offset: 1,
                color: 'rgba(243, 152, 0, 0)'
              }])
            }
          },
        ]
      };
      myChart.setOption(option);
    }
  },
  mounted() {
    this.getAnnounce();
  }
}
</script>

<style lang="less" scoped>
.top {
  padding: 0 1px 0 2%;
  height: 82px;
}

.w1, .w2 {
  display: inline-block;
  vertical-align: bottom;
  border-radius: 3px 3px 0px 0px;
}

.w1 {
  .yuan {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 7px;

    &.bg1 {
      background: #A465E1;
    }

    &.bg2 {
      background: #4392DD;
    }

    &.bg3 {
      background: #5363E7;
    }

    &.bg4 {
      background: #ED6A52;
    }
  }

  .t {
    margin-right: 3px;

    &.c1 {
      color: #BE8CEF;
    }

    &.c2 {
      color: #57A3EB;
    }

    &.c3 {
      color: #8792F2;
    }

    &.c4 {
      color: #F0745D;
    }

  }

  width: 49.5%;
  height: 57px;
  background: #FFFFFF;
  font-size: 16px;
  text-align: center;
  line-height: 57px;
}

.w2 {
  width: 42.5%;
  height: 82px;

  .t2 {
    margin-top: 41px;
    margin-left: 14%;
    display: block;
    font-size: 20px;
    font-weight: bold;
    color: #FFFFFF;

  }

  &.bg1 {
    background: #A465E1 url(../../static/images/daifache.png) no-repeat center center;
    background-size: contain;
  }

  &.bg2 {
    background: #4392DD url(../../static/images/yunshuzhong.png) no-repeat center center;
    background-size: contain;
  }

  &.bg3 {
    background: #5363E7 url(../../static/images/daoda.png) no-repeat center center;
    background-size: contain;
  }

  &.bg4 {
    background: #ED6A52 url(../../static/images/chaoshi.png) no-repeat center center;
    background-size: contain;
  }
}

.msg {
  margin-top: 15px;

  .m1 {
    display: inline-block;
    width: 58.4%;
    height: 422px;
    background: #FFFFFF;
    vertical-align: top;
  }

  .m2 {
    display: inline-block;
    // margin-left: 1.6%;
    width: 100%;
    height: 422px;
    background: #FFFFFF;
    vertical-align: top;
    position: relative;
  }
}

.m2-b {
  padding: 10px 33px 0px;
}

.m2-t {
  margin-left: 20px;
  font-size: 17px;
  font-weight: bold;
  color: #070910;
}

.m2-i {
  width: 32px;
  vertical-align: text-bottom;
}

.m2-c {
  padding: 19px 48px 45px;
  height: 300px;
}

.line {
  // width: 87.7%;
  border-bottom: 1px solid #E5E5E5;
  margin: 0 auto;
}

.title {
  font-size: 16px;
  color: #29292C;
}

.time {
  font-size: 12px;
  color: #999999;
  margin-top: 9px;
}

.content {
  margin-top: 27px;
  font-size: 12px;
  color: #666666;
  line-height: 23px;
}

.btns {
  position: absolute;
  bottom: 19px;
  right: 22px;
}

.lr {
  font-size: 25px;
}

.tc {
  text-align: center;
}

.tr {
  text-align: right;
}

.el-carousel {
  height: 100% !important;
}

/deep/ .el-carousel__container, /deep/ .el-carousel__item {
  height: 100% !important;
}
/deep/ .el-carousel__item {
  overflow-y: auto;
}
/deep/ .el-carousel__item::-webkit-scrollbar {
  /*滚动条整体样式*/
  width : 5px;  /*高宽分别对应横竖滚动条的尺寸*/
  height: 5px;
}
/deep/ .el-carousel__item::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  box-shadow   : inset 0 0 3px rgba(0, 0, 0, 0.2);
  background   : #b4b4b4;
}
/deep/ .el-carousel__item::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow   : inset 0 0 3px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  background   : #FFFFFF;
}

.chart-box {
  height: 277px;
  background: #FFFFFF;
  position: relative;
}

.chart {
  height: 277px;
}

.biaoji {
  position: absolute;
  top: 92px;
  right: 30px;
  font-size: 14px;
  z-index: 9999;

  .t1 {
    color: #F39800;
  }

  .t2 {
    margin-top: 88px;
    color: #EC6941;
  }
}
</style>
